<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-5">
            My aggregated reports
          </h1>
        </div>
      </div>
      <div class="survey-table">
        <BaseModal v-model="wipeconfirm" hide-footer title="Delete survey permanently?">
          <div v-if="wipereports.length > 0">
            Are you sure you want to delete these reports?
            <ul class="mt-3">
              <li v-for="report in wipereports" :key="report.id" class="mb-1">{{ report.name }} ({{ report.id }})</li>
            </ul>
          </div>
          <button class="btn btn-danger mt-3 w-100" type="button" @click="delete_many()">
            Delete
          </button>
          <button class="btn btn-secondary mt-2 w-100" type="button" @click="wipeconfirm = false; wipesurvey = false;">
            Cancel
          </button>
        </BaseModal>
        <BaseModal v-model="wipeprogress" hide-footer title="Permanently deleting reports">
          <div class="row">
            <div class="col-12 text-center">
              <h5>Deleting reports</h5>
            </div>
          </div>
          <div class="col-12 text-center">
            <div class="spinner-border text-danger" style="width: 4rem; height: 4rem;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </BaseModal>
        <div class="table-filter-area">
          <div>
            <div class="mb-3">
              <input
                type="text"
                class="form-control"
                v-model="search"
                @input="handleSearch"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="table-button-area mb-3">
            <div class="d-flex justify-content-end">
              <div>
                <button class="btn btn-small btn-secondary" type="button" @click="clearFilters">Clear filter</button>
                <button class="btn btn-small btn-secondary" type="button" @click.prevent="wipeconfirm = true"
                  :disabled="wipereports.length === 0">
                  Delete
                </button>
              </div>
            </div>
          </div>

        </div>

        <BaseTable
          responsive
          hover
          class="table surveytable"
          :busy="loading"
          :items="reports"
          :fields="fields"
          @row-clicked="report_download"
        >
          <template #head(select)>
            <input type="checkbox" :checked="allSelected" @change="selectall($event.target.checked)" />
          </template>

          <template #cell(select)="{ data }">
            <div>
              <input type="checkbox" v-model="data.item.selected" @change="countselected" />
            </div>
          </template>

          <template #cell(report_name)="{ data }">
            <span :class="`${anon ? 'g-anon' : ''}`">
              <i class="fa fa-regular fa-file-chart-column"></i>&nbsp;&nbsp;{{ data.item.report_name }}
            </span>
          </template>

          <template #cell(report_date)="{ data }">
            {{ format_date(data.item.report_date) }}
          </template>

          <template #cell(survey_type)="{ data }">
            {{ data.item.survey_type }}
          </template>

          <template #cell(normvalues_id)="{ data }">
            {{ normvalues_country_name(data.item.normvalues_id) }}
          </template>

          <template #cell(language_id)="{ data }">
            <lang-flag :iso="flag_code(data.item.language_id)" :squared="false" />{{ data.item.language_id }}
          </template>

          <template #cell(actions)="{ data }">
            <BaseDropdown right class="w-100">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="report_download_file(data.item.id)">Download</a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="record_delete_confirm(data.item.id)">
                  Delete
                </a>
              </li>
            </BaseDropdown>
          </template>

          <template #empty>
            <div class="text-center text-success my-2">
              <strong>No reports found</strong>
            </div>
          </template>
        </BaseTable>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '../Breadcrumb.vue'
import Navbar from '../Navbar.vue'
import LangFlag from 'vue-lang-code-flags'
import { config } from '../../../config'
import BaseModal from '../base/BaseModal.vue'
import BaseTable from '../base/BaseTable.vue'
import BaseDropdown from '../base/BaseDropdown.vue'

export default {
  components: {
    LangFlag,
    Navbar,
    Breadcrumb,
    BaseModal,
    BaseTable,
    BaseDropdown
  },
  data () {
    return {
      reports: [],
      wipeconfirm: false,
      wipeprogress: false,
      allSelected: false,
      fields: [
        { key: 'select', label: 'S', sortable: false, tdClass: 'select-td', thClass: 'select-th' },
        { key: 'id', label: 'ID', sortable: false },
        { key: 'report_name', sortable: true, label: 'Report name', tdClass: 'w-50' },
        { key: 'report_date', sortable: true, label: 'Date' },
        { key: 'survey_type', sortable: true, label: 'Survey type' },
        { key: 'normvalues_id', sortable: true, label: 'Norm' },
        { key: 'language_id', sortable: true, label: 'Language' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      search: '',
      wipereports: [],
      visible: this.$store.state.mypage_reports_open,
      deleteshow: false,
      currentPage: 1,
      perPage: 25,
      retrieved: 0,
      languages: [],
      loading: true,
      rows: 0,
      orderby: 'report_date',
      orderdesc: true,
      normvalues_countries: this.$store.state.normvalues_countries
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    mygdqpage_reload: {
      get () {
        return this.$store.state.mygdqpage_reload
      }
    },
    setadmin_done: {
      get () {
        return this.$store.state.questionnaire_admin_done
      }
    },
    groups: {
      get () {
        const items = this.$store.state.groups.filter(f => f.group_deleted === 0)
        const groups = [{
          value: null,
          text: 'Select group',
          disabled: true
        }]
        for (let i = 0; i < items.length; i++) {
          const option = {
            value: items[i].id,
            text: items[i].group_name
          }
          groups.push(option)
        }
        return groups
      },
      set () {
        return true
      }
    }
  },
  watch: {
  },
  created () {
    this.loading = true
    this.normvalues_countries_get()
    this.languages_get()
    this.reports_get()
  },
  methods: {
    clearFilters () {
      this.search = ''
      this.allSelected = false
      this.reports_get()
    },

    handleSearch () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.reports_get()
      }, 1000)
    },

    filter_table () {
      this.allSelected = false
      this.reports_get()
    },

    selectall (event) {
      this.allSelected = event
      this.reports.forEach(report => {
        report.selected = this.allSelected
      })
      this.countselected()
    },

    countselected () {
      const selectedreports = this.reports
        .filter(r => r.selected === true)
        .map(r => ({ id: r.id, name: r.report_name }))
      this.reportsselected = selectedreports.length
      this.wipereports = selectedreports
    },

    languages_get () {
      this.$store.dispatch('languages_fetch')
        .then((resp) => {
          this.languages = resp.data.result.map(l => {
            return {
              value: l.id,
              text: l.language_name,
              code: l.language_code
            }
          })
        })
    },
    format_date (date) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      const year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    flag_code: function (name) {
      let flag_code = ''
      for (let i = 0; i < this.languages.length; i++) {
        if (this.languages[i].text === name) {
          flag_code = this.languages[i].code
          break
        }
      }
      return flag_code
    },
    normvalues_country_name: function (norm_id) {
      let normvalues_country_name = ''
      for (let i = 0; i < this.normvalues_countries.length; i++) {
        if (this.normvalues_countries[i].country_id === norm_id) {
          normvalues_country_name = this.normvalues_countries[i].country_name
        }
      }
      return normvalues_country_name
    },
    normvalues_countries_get: function () {
      const survey_type_id = 1
      this.$store.dispatch('normvalues_countries_fetch')
        .then((resp) => {
          const options = [{ value: 0, text: 'Please select norm values' }]
          for (let i = 0; i < resp.data.length; i++) {
            if (resp.data[i].country_id === 999 || survey_type_id === 1) {
              options.push({
                value: resp.data[i].country_id,
                text: resp.data[i].country_name
              })
            }
          }
          this.norm_values_options = options
        })
    },
    data_sort (context) {
      this.orderby = context.sortBy
      this.orderdesc = context.sortDesc
      this.currentPage = 1
      this.reports_get()
    },
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setagreportsopen', this.visible)
    },
    record_delete_confirm (id) {
      let deleting = false
      if (confirm('Are you sure you want to delete this report?')) {
        deleting = true
      } else {
        deleting = false
      }

      if (deleting) {
        this.record_delete(id)
        this.reports_get()
      }
    },
    delete_many () {
      this.wipereports.forEach((item) => {
        this.record_delete(item.id)
      })
      this.wipereports = []
      this.wipeprogress = false
      this.wipeconfirm = false
      this.reports_get()
    },
    record_delete (id) {
      this.$store.dispatch('record_delete', {
        table_name: 'g_agreports',
        id
      })
    },
    record_delete_cancel () {
      this.deleteshow = false
    },
    reports_get: function () {
      this.loading = true
      this.$store
        .dispatch('aggregatedreports_get', {
          user_id: this.$store.state.user_id,
          start: (this.currentPage - 1) * this.perPage,
          limit: this.perPage,
          orderby: this.orderby,
          filter: {
            report_name: { operator: 'LIKE', value: `*${this.search}*` }
          },
          order: (this.orderdesc ? 'DESC' : 'ASC')
        })
        .then(result => {
          const reports = result.data.result
          this.retrieved = result.data.result.length
          this.rows = result.data.total
          this.reports = reports
          this.loading = false
        })
    },
    report_download_file (report_id) {
      const reporturl = config.report_url + '/gdq_agreport.php?r=' + report_id
      const downloadURL = new URL(reporturl)
      const downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute('download', 'GDQ_AGReport_' + new Date().toISOString().split('T')[0])
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    report_download (item, index, event) {
      const element = event.target
      const includedTags = ['span', 'i']

      if (includedTags.includes(element.tagName.toLowerCase())) {
        this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: item.id })
          .then(() => {
            this.$router.push('/aggregatedreports')
          })
      }

      const isFirstElement = !element.previousSibling
      const isLastElement = !element.nextSibling

      if (!isLastElement && !isFirstElement) {
        this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: item.id })
          .then(() => {
            this.$router.push('/aggregatedreports')
          })
      }
    }
  }
}
</script>
<style>
td {
  cursor: pointer !important;
}
</style>
